
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/id-verification",
      function () {
        return require("private-next-pages/id-verification.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/id-verification"])
      });
    }
  